
import {
    defineComponent
} from "vue";
import Dropdown3 from "@/components/dropdown/Dropdown3.vue";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "widget-1",
    components: {
        Dropdown3,
    },
    props: {
        widgetClasses: String,
        widgetColor: String,
        chartHeight: Number,
        loading: Boolean,
        widgetTitle: String,
        widgetAmount: Number,
        itemsList: null,
        itemsTwo: {
          type: null,
          required: false,
          default: []
        },
    },
    setup() {
        const { t } = useI18n();
        const items = [];

        return {
            t,
            items,
        };
    },
});
